module.exports = __webpack_public_path__ + "img/MASTER_ENG_VP_Handbook_Web31.bf63afc0.jpg";